export default function getRandomPastelColor() {
    const pastelColors = ['#C9A0DC', '#F4C2C2', '#B0E0E6', '#F5DEB3', '#E6E6FA'];
    return pastelColors[Math.floor(Math.random() * pastelColors.length)];
}